import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useState } from "react";
import { MessageType, warehouseIOType } from "types/enum";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { getWarehouses } from "./api";
import { WarehouseIOForm } from "./WarehouseIOForm";

export const WarehouseIo = ({type}) => {
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [response, setResponse] = useState<any>([]);
  const [selectedObj, setSelectedObj] = useState<string | any>(null);
  const [mode, setMode] = useState("");
  const [forceUpdate, setForceUpdate] = useState(false);
  const [showWarehouseIoForm, setShowWarehouseIoForm] = useState(false);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(25);
  const [search, setsearch] = useState(null);
  const [filterAndSort, setFilterAndSort] = useState<any>(null);
  const layoutContext = useContext(LayoutContext);
  const [pages, setPages] = useState<number>(0);
  const [buttonPrintObj, setButtonPrintObj] = useState<any>()




  const searchHandler = (str) => {
    setPageNum(1);
    setSelectedObj(null);
    if (str === "") {
      setsearch(null);
      getWarehouseIoAsync(1, null);
    } else {
      setsearch(str);
      getWarehouseIoAsync(1, str);
    }
  };

  const handleChangePageSize = (e: any) => {
    setPageNum(1);
    setPageSize(e.currentTarget.value);
    getPageSize("WarehouseIo", e.currentTarget.value);
    getWarehouseIoAsync(1);
  };
  const handleGoPage = (value) => {
    if (value) {
      setPageNum(+value);
      getWarehouseIoAsync(+value);
    } else {
    }
  };
  const handleNextPage = () => {
    if (response.TotalRecords && response.TotalRecords / pageSize > pageNum) {
      setPageNum((pageNum) => {
        return +pageNum + 1;
      });
      getWarehouseIoAsync(pageNum + 1);
    }
  };
  const handlePrevPage = () => {
    if (pageNum > 1) {
      setPageNum((pageNum) => {
        return +pageNum - 1;
      });
      getWarehouseIoAsync(pageNum - 1);
    }
  };

  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
  };



  /* #region toolbarActions */
  const clickToolbarCallback = (clickedButtonName: string) => {
    switch (clickedButtonName.toLowerCase()) {
      case "print":
        alert("print ");
        break;
      case "excel":
        downloadCSV(response?.Data, 6, trans("WarehouseIo"));
        break;
      case "refresh":
        setForceUpdate(!forceUpdate);
        break;
      case "create":{
        setSelectedObj(null)
        setMode("create");
        setShowWarehouseIoForm(true)
      }

        break;
      case "view":
        if (selectedObj) {
          setMode("view");
          setShowWarehouseIoForm(true);
        }
         else {
          // Toast(trans("Msg_SelectRow"), "warning");
          Toast(trans("Msg_SelectRow"), MessageType.warning);

        }
        break;
        case "edit":
            if (selectedObj) {
              setMode("edit");
              setShowWarehouseIoForm(true);
            }
             else {
              // Toast(trans("Msg_SelectRow"), "warning");
              Toast(trans("Msg_SelectRow"), MessageType.warning);

            }
            break;
      // case "edit": if (selectedObj){setMode("edit");setShowSalesOrderForm(true)}; break;
      case "help":
        alert("call api help");
        break;
    }
  };
  /* #endregion */

  async function getWarehouseIoAsync(pagNum = pageNum, searchSTR = search) {

       if(!JSON.parse(localStorage.getItem('DefaultInventory') as any)?.Id){
       Toast('msg_choosewarehouse',MessageType.warning)
       setLoading(true)
       return null
    }

    setLoading(false);
    try {
      let pageSizeChangedByUser = getPageSize("WarehouseIo");
      setPageSize(pageSizeChangedByUser);
      if (layoutContext.currentApplication != undefined) {
        const currentWarehouse=JSON.parse(localStorage.getItem('DefaultInventory') as any)?.Id

        const res = await getWarehouses(
          pagNum,
          pageSizeChangedByUser,
          searchSTR,
          filterAndSort?.OrderFormat?.join(","),
          filterAndSort?.Filterlist,
          currentWarehouse,
          warehouseIOType[type]
        );
        if (res.Data.Data.length > 0) {
          setResponse(res.Data);

          setPages(
            res.Data.TotalRecords > pageSizeChangedByUser
              ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser)
              : 1
          );
        }
      }
    } catch (error) {
      setMessageType("error");
    }
    setLoading(true);
  }
  useEffect(() => {
    setSelectedObj(null);
    setResponse(null);
    if (
      filterAndSort != null &&
      layoutContext.currentApplication != undefined
    ) {
        getWarehouseIoAsync();
    }
  }, [forceUpdate, filterAndSort, layoutContext.currentApplication?.Id,type]);
  useEffect(() => {
    let settings = getGridSetting("WarehouseIo");
    setFilterAndSort({ Filterlist: settings[0], OrderFormat: settings[1] });
  }, []);



  return (
    <>
      {showWarehouseIoForm  ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowWarehouseIoForm(false);
            setButtonPrintObj(null)
          }}
          show={showWarehouseIoForm}
          title={trans(warehouseIOType?.[type])}
          buttonPrintObj={buttonPrintObj}
        >
          <WarehouseIOForm
            buttonPrintObjCallBack={setButtonPrintObj}
            selectedObj={selectedObj}
            mode={mode}
            showForm={showWarehouseIoForm}
            reload={() => {
              setForceUpdate(!forceUpdate);
            }}
            onHide={() => {
              setShowWarehouseIoForm(false);
              setButtonPrintObj(null)
            }}
            // type={mode=='create'?warehouseIOType?.[warehouseIoType]:warehouseIOType[selectedObj.WarehouseIOTypeEnum]}
            type={warehouseIOType?.[type]}
            setForceUpdate={setForceUpdate}
            setShowWarehouseIoForm={setShowWarehouseIoForm}
            forceUpdate={forceUpdate}
          />
        </ModalForm>
      ) : null}
      <Toolbar  
       edit={!JSON.parse(localStorage.getItem('DefaultInventory') as any)?.Id?false:type==warehouseIOType.InventoryReceipt ||type==warehouseIOType.DirectDelivery|| type==warehouseIOType.ReturnRemittance|| type==warehouseIOType.InventoryBalancing||type==warehouseIOType.TransferRemittance?true:false}
        view={!JSON.parse(localStorage.getItem('DefaultInventory') as any)?.Id?false:true}
        create={!JSON.parse(localStorage.getItem('DefaultInventory') as any)?.Id?false:type!=warehouseIOType.InventoryRemittance?true:false || true}
        handleSearch={searchHandler}
        id={selectedObj?.Id}
        emptyList={response?.TotalRecords == 0}
        search={true}
        handleClickToolbar={clickToolbarCallback}
        // createWarehouseIoForm={"WarehouseForms"}
        // handleCreateWarehouseIo={(e)=>{handleCreateWarehouseIo(e)}}
        warehouse={true}
      />
      <div
        style={{ overflowY: "auto", height: "70vh", scrollbarWidth: "thin" }}
        className="col-lg-12 mt-0"
      >
        {loading ? (
          <>
            {response?.Data?.length > 0 ? (
              <div className="card">
                <div className="card-body p-0">
                  <>
                    <DataGrid
                      DoubleClick={(obj) => {
                        setSelectedObj(obj);
                        clickToolbarCallback("view");
                      }}
                      View={true}
                      ViewParametr={"NotSeen"}
                      handlefiltering={(str: any) => {
                        str.Filterlist != undefined
                          ? setFilterAndSort(str)
                          : setFilterAndSort({
                              ...filterAndSort,
                              Filterlist: str,
                            });
                      }}
                      filterStr={filterAndSort.Filterlist}
                      orderFormatList={filterAndSort.OrderFormat}
                      orderFormat={(order) => {
                        setFilterAndSort({
                          ...filterAndSort,
                          OrderFormat: order,
                        });
                      }}
                      parentName={"warehouseIo"}
                      theadData={Object.keys(response.Data[0])}
                      tbodyData={response.Data}
                      minCellWidth={80}
                      selectedRowObjectCallback={selectedObjCallback}
                      rowSelected={selectedObj}
                      startIndex={4}
                      handleView={(e) => {
                        setSelectedObj({ Id: e });
                        setMode("view");
                        setShowWarehouseIoForm(true);
                      }}
                         handleEdit={
                          type==warehouseIOType.InventoryReceipt || type==warehouseIOType.InventoryBalancing?
                          (e) => {
                        setSelectedObj({ Id: e });
                
              setMode("edit");
              setShowWarehouseIoForm(true);
            
                      }:null}

                      totalRecords={response.TotalRecords}
                      pageNum={pageNum}
                      pageSize={pageSize}
                      HandleNextPage={handleNextPage}
                      HandlePrevPage={handlePrevPage}
                      handlechangePageSize={handleChangePageSize}
                      first={() => {
                        getWarehouseIoAsync(pages);
                        setPageNum(pages);
                      }}
                      end={() => {
                        getWarehouseIoAsync(1);
                        setPageNum(1);
                      }}
                      handleGoPage={handleGoPage}
                    />
                  </>
                </div>
              </div>
            ) : (
              <Message message={!JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id?'msg_choosewarehouse':"NoDataForPreview"} type={!JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id?'error':messageType} />
            )}
          </>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
};
